import script from "./ChallengeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeCard.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeCard.vue?vue&type=style&index=0&id=036bb030&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036bb030"]])

export default __exports__